import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const TOKEN_KEY = "silky_token";

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// FastAPI 422 returns `detail` as an array of {msg,...} objects. Flatten safely.
export function formatApiError(err, fallback = "Something went wrong.") {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return (
      detail
        .map((e) =>
          e && typeof e.msg === "string" ? e.msg : JSON.stringify(e),
        )
        .filter(Boolean)
        .join(" · ") || fallback
    );
  }
  if (detail && typeof detail === "object") {
    if (typeof detail.msg === "string") return detail.msg;
    if (typeof detail.error === "string") return detail.error;
    return JSON.stringify(detail);
  }
  return String(detail);
}

export function getOutOfAreaPayload(err) {
  const detail = err?.response?.data?.detail;
  if (detail && typeof detail === "object" && detail.error === "out_of_area") {
    return detail;
  }
  return null;
}
